/** The route answers `204` without a body: the payload only names what to reload. */
export type SubjectMemberRemovedPayload = { subjectId: number; userId: number };

export type SubjectMemberRemovedAction = {
	type: 'SUBJECT_MEMBER_REMOVED';
	payload: SubjectMemberRemovedPayload;
};

export default (subjectId: number, userId: number): SubjectMemberRemovedAction => ({
	type: 'SUBJECT_MEMBER_REMOVED',
	payload: { subjectId, userId },
});
